export enum PersonalDataProcessingAgreementType {
  PERSONAL_DATA_ASSISTANT = 'PERSONAL_DATA_ASSISTANT'
}
